import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePickerButton from "../../../components/DateRangePicker/DateRangePickerButton";
import { customSelectStyles } from "../../../shared/constants";
import { ISessionActivityFilters } from "../interface";
import { useAuth } from "../../../hooks";
import { useTheme } from "../../../providers/ThemeProvider";
import { Button } from "flowbite-react";
import { ArrowClockwise } from "@phosphor-icons/react";

export type UserOption = { value: string; label: string };

interface Props {
  values: ISessionActivityFilters;
  onChange: (v: ISessionActivityFilters) => void;
  userOptions: UserOption[];
  refetch: () => void;
  isRefetching: boolean;
}

const SessionFilter: React.FC<Props> = ({
  values,
  onChange,
  userOptions,
  refetch,
  isRefetching,
}) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const { user } = useAuth();

  // Convert string dates to Date objects for the picker
  const initialStartDate = values.from_date
    ? new Date(values.from_date)
    : undefined;
  const initialEndDate = values.to_date ? new Date(values.to_date) : undefined;

  return (
    <div className="flex flex-wrap gap-2 items-end">
      <Button
        size="sm"
        color="light"
        onClick={() => refetch()}
        disabled={isRefetching}
      >
        <div className="flex items-center gap-1">
          {t("common.refresh")}
          <ArrowClockwise
            size={16}
            weight="duotone"
            className={`${isRefetching ? "animate-spin" : ""}`}
          />
        </div>
      </Button>
      <div style={{ minWidth: 240 }}>
        <Select
          options={userOptions}
          value={userOptions.find((o) => o.value === values.user_id)}
          onChange={(opt) =>
            onChange({
              ...values,
              user_id: (opt as UserOption)?.value || String(user?.id) || "",
            })
          }
          classNamePrefix="custom-select"
          styles={customSelectStyles<UserOption>(isDark)}
          isClearable={true}
          placeholder={t("common.users", "Users") as string}
        />
      </div>
      <DateRangePickerButton
        onDateRangeChange={(start, end) => {
          onChange({
            ...values,
            from_date: start ? start.toISOString().slice(0, 10) : undefined,
            to_date: end ? end.toISOString().slice(0, 10) : undefined,
          });
        }}
        initialStartDate={initialStartDate}
        initialEndDate={initialEndDate}
        onPresetChange={() => {}}
      />
    </div>
  );
};

export default SessionFilter;
